import * as types from './mutation-types'


export const loadQvctCategorie = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/qvct/survey/categories/collection', data).then((response) => {
            commit(types.LOAD_QVCT_CARTEGORIE, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadQvctCategorieType = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/qvct/category/type/enum', data).then((response) => {
            commit(types.LOAD_QVCT_CARTEGORIE_TYPE, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}



export const storeQvctCategorie = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/qvct/survey/categories', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const updateQvctCategorie = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`update/qvct/survey/categories/${data.id}`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteQvctCategorie = ({commit}, {id}) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`delete/qvct/survey/categories/${id}`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
